import { useFormatCurrency } from "@/formatters/use-format-currency"

// Whole units on small amounts hid the cents that make children add up to
// their parent: seven days of $3.29 read "$3" each, so the cards showed $21
// under a $23 week (PROD-10719). Below this, show cents.
const CENTS_BELOW = 10

const WHOLE = { minimumFractionDigits: 0, maximumFractionDigits: 0 }
const CENTS = { minimumFractionDigits: 2, maximumFractionDigits: 2 }

/** E2 waste amounts: whole units from 10, cents below. */
export const useFormatWasteCurrency = () => {
  const { formatCurrency: formatWhole } = useFormatCurrency(WHOLE)
  const { formatCurrency: formatCents } = useFormatCurrency(CENTS)
  return (value: number) =>
    Math.abs(value) < CENTS_BELOW ? formatCents(value) : formatWhole(value)
}
